import { Linkedin, ThumbsUp, MessageCircle, Repeat2, Send } from "lucide-react";
import type { PreviewProps } from "../types";
import { PreviewShell, MediaSlot } from "./PreviewShell";

export function LinkedinPreview(props: PreviewProps) {
  return (
    <PreviewShell device={props.device}>
      <div className="flex items-center gap-2.5 p-3">
        {props.pageAvatarUrl ? (
          <img
            src={props.pageAvatarUrl}
            alt={props.pageName}
            className="w-12 h-12 rounded-full object-cover bg-gray-100"
          />
        ) : (
          <div className="w-12 h-12 rounded-full flex items-center justify-center bg-blue-50">
            <Linkedin size={20} className="text-[#0A66C2]" />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <p className="text-[13px] font-semibold text-gray-900 truncate">{props.pageName}</p>
          <p className="text-[11px] text-gray-500 truncate">Page · 1,234 followers</p>
          <p className="text-[11px] text-gray-400">1h · 🌐</p>
        </div>
      </div>
      {props.caption && (
        <div className="px-3 pb-2">
          <p className="text-[12px] text-gray-800 whitespace-pre-wrap leading-relaxed">
            {props.caption}
          </p>
        </div>
      )}
      <MediaSlot mediaUrl={props.mediaUrl} mediaType={props.mediaType} aspect="aspect-[1.91/1]" />
      <div className="flex items-center justify-around py-2 border-t border-gray-100 text-[11px] text-gray-500">
        <span className="flex items-center gap-1.5">
          <ThumbsUp size={14} /> Like
        </span>
        <span className="flex items-center gap-1.5">
          <MessageCircle size={14} /> Comment
        </span>
        <span className="flex items-center gap-1.5">
          <Repeat2 size={14} /> Repost
        </span>
        <span className="flex items-center gap-1.5">
          <Send size={14} /> Send
        </span>
      </div>
    </PreviewShell>
  );
}
